(()=>{
  const wide=matchMedia('(min-width:1024px)');
  const bindMenus=()=>{
    document.querySelectorAll('.header details[level="top"]').forEach(menu=>{
      if(menu.dataset.fvHover)return;menu.dataset.fvHover='true';let timer,keyboardActive=false;
      const summary=menu.querySelector(':scope > summary');
      if(!summary)return;
      // Native details hover includes the entire absolute submenu, including blank space.
      menu.setAttribute('trigger','click');
      const cancelClose=()=>{clearTimeout(timer);timer=undefined;};
      const closeSoon=()=>{
        if(!wide.matches||timer!==undefined)return;
        timer=setTimeout(()=>{timer=undefined;if(!keyboardActive||!menu.contains(document.activeElement))menu.open=false;},240);
      };
      const pointerInContent=event=>{
        const panel=summary.nextElementSibling;
        if(!panel||!menu.open)return false;
        const clip=panel.getBoundingClientRect();
        if(event.clientX<clip.left||event.clientX>clip.right||event.clientY<clip.top||event.clientY>clip.bottom)return false;
        const groups=panel.querySelectorAll('.mega-menu__nav > li');
        const regions=groups.length?[...groups]:[panel];
        return regions.some(region=>{
          const links=[...region.querySelectorAll('a,button')].filter(link=>link.getClientRects().length);
          if(!links.length)return false;
          const rects=links.map(link=>link.getBoundingClientRect());
          return event.clientX>=Math.min(...rects.map(r=>r.left))-12&&event.clientX<=Math.max(...rects.map(r=>r.right))+12&&event.clientY>=Math.min(...rects.map(r=>r.top))-12&&event.clientY<=Math.max(...rects.map(r=>r.bottom))+12;
        });
      };
      summary.addEventListener('click',event=>{
        if(!wide.matches||event.detail===0||event.pointerType==='touch'||event.sourceCapabilities?.firesTouchEvents)return;
        const link=event.currentTarget.dataset.link;
        if(link){event.preventDefault();event.stopImmediatePropagation();window.location.assign(link);}
      },true);
      summary.addEventListener('pointerenter',event=>{
        if(!wide.matches||event.pointerType==='touch'||event.sourceCapabilities?.firesTouchEvents)return;
        keyboardActive=false;
        cancelClose();
        document.querySelectorAll('.header details[level="top"][open]').forEach(other=>{if(other!==menu)other.open=false;});
        menu.open=true;
      });
      summary.addEventListener('pointerleave',closeSoon);
      summary.nextElementSibling?.addEventListener('pointermove',event=>{
        if(!wide.matches||event.pointerType==='touch')return;
        keyboardActive=false;
        if(pointerInContent(event))cancelClose();else closeSoon();
      });
      menu.addEventListener('pointerleave',closeSoon);
      menu.addEventListener('keydown',event=>{
        keyboardActive=true;
        if(event.key==='Escape'){cancelClose();menu.open=false;summary.focus();}
      });
    });
  };
  const bindFooter=()=>{
    const small=matchMedia('(max-width:767px)');
    const update=()=>document.querySelectorAll('.fc-footer-links').forEach(row=>{row.open=!small.matches;});
    update();small.addEventListener('change',update);
  };
  class FovielPairing extends HTMLElement{
    connectedCallback(){
      this.dataset.fvBundleInitialization='started';
      if(this.bound)return;this.bound=true;
      this.form=this.querySelector('form');
      if(!this.form){this.dataset.fvBundleInitialization='form-not-ready';return;}
      this.button=this.form.querySelector('button[type="submit"]');
      this.status=this.querySelector('[data-fv-pair-status]');
      this.rows=[...this.querySelectorAll('[data-fv-pair-row]')];
      const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency}).format(value/100);
      this.update=()=>{
        const state=this.rows.map(row=>{
          const select=row.querySelector('[data-fv-pair-variant]'),option=select.tagName==='SELECT'?select.selectedOptions[0]:select;
          const included=row.querySelector('[data-fv-include]').checked;
          const price=Number(option?.dataset.price||0);
          const image=row.querySelector('img');
          if(image&&option?.dataset.image){image.removeAttribute('srcset');image.src=option.dataset.image;image.alt=option.dataset.label||option.textContent.trim();}
          row.querySelector('[data-fv-pair-quantity]').disabled=!included;
          select.disabled=!included;
          return{row,select,option,included,price};
        });
        this.eligible=!this.mainVariantUnavailable&&state.length===3&&state.every(s=>s.included&&s.option&&!s.option.disabled);
        const subtotal=state.reduce((sum,s)=>sum+(s.included?s.price:0),0);
        const saving=this.eligible?Math.round(subtotal*20/100):0;
        // Allocate integer pennies so the displayed item prices add up to the bundle total.
        const discounts=state.map(s=>this.eligible?Math.floor(s.price*20/100):0);
        let remainder=saving-discounts.reduce((sum,n)=>sum+n,0);
        const order=state.map((s,i)=>({i,fraction:(s.price*20)%100})).sort((a,b)=>b.fraction-a.fraction||a.i-b.i);
        for(const{ i }of order){if(remainder<=0)break;discounts[i]++;remainder--;}
        state.forEach((s,i)=>{
          const original=s.row.querySelector('[data-fv-row-original]');
          original.textContent=money(s.price);original.hidden=!this.eligible;
          s.row.querySelector('[data-fv-row-price]').textContent=money(s.price-discounts[i]);
        });
        const original=this.querySelector('[data-fv-total-original]');
        original.textContent=money(subtotal);original.hidden=!this.eligible;
        this.querySelector('[data-fv-total]').textContent=money(subtotal-saving);
        this.querySelector('[data-fv-saving-amount]').textContent=money(saving);
        this.querySelector('[data-fv-savings]').hidden=!this.eligible;
        this.querySelector('[data-fv-requirement]').hidden=this.eligible;
        this.button.disabled=this.busy||!this.eligible;
      };
      this.form.addEventListener('change',()=>{this.status.textContent='';this.update();});
      this.button.addEventListener('click',()=>{this.dataset.fvBundleAction='button-click';},true);
      this.form.addEventListener('submit',async event=>{
        event.preventDefault();
        this.dataset.fvBundleAction='submit';
        if(this.added){window.location.assign(this.dataset.discountUrl);return;}
        if(this.busy)return;
        this.update();if(!this.eligible)return;
        this.busy=true;this.button.disabled=true;this.button.textContent=this.button.dataset.adding;
        this.form.setAttribute('aria-busy','true');this.status.textContent='';
        this.bundleKey=this.bundleKey||(crypto.randomUUID?crypto.randomUUID():String(Date.now()));
        const controls=[...this.form.querySelectorAll('select,input[type="checkbox"]')];
        controls.forEach(control=>control.disabled=true);
        const items=this.rows.map(row=>({id:row.querySelector('[data-fv-pair-variant]').value,quantity:1,properties:{_foviel_bundle:this.bundleKey}}));
        const headers={'Content-Type':'application/json','Accept':'application/json'};
        try{
          this.dataset.fvBundleAction='adding';
          const added=await fetch(this.dataset.addUrl,{method:'POST',credentials:'same-origin',headers,body:JSON.stringify({items})});
          const result=await added.json();
          if(!added.ok)throw new Error(result.description||this.status.dataset.error);
          this.added=true;
          this.dataset.fvBundleAction='added';
          const discounted=await fetch(this.dataset.updateUrl,{method:'POST',credentials:'same-origin',headers,body:JSON.stringify({discount:this.dataset.bundleCode})});
          if(!discounted.ok){window.location.assign(this.dataset.discountUrl);return;}
          const cart=await discounted.json();
          if(cart.discount_codes&&!cart.discount_codes.some(code=>code.code.toUpperCase()===this.dataset.bundleCode&&code.applicable)){
            window.location.assign(this.dataset.discountUrl);return;
          }
          window.location.assign(this.dataset.cartUrl);
        }catch(error){
          this.dataset.fvBundleAction='error';
          if(this.added){window.location.assign(this.dataset.discountUrl);return;}
          // A stock change can cause a partial multi-add. Review those items instead of adding twice.
          try{
            const response=await fetch(this.dataset.cartUrl+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
            if(response.ok){
              const cart=await response.json();
              if(cart.items?.some(item=>item.properties?._foviel_bundle===this.bundleKey)){
                this.added=true;this.status.textContent=this.status.dataset.partial;
                this.button.textContent=this.status.dataset.review;
                this.busy=false;this.button.disabled=false;this.form.removeAttribute('aria-busy');
                this.button.addEventListener('click',event=>{event.preventDefault();window.location.assign(this.dataset.cartUrl);},{once:true});
                return;
              }
            }
          }catch{}
          this.busy=false;controls.forEach(control=>control.disabled=false);this.form.removeAttribute('aria-busy');
          this.button.textContent=this.button.dataset.label;this.status.textContent=error.message||this.status.dataset.error;this.update();
        }
      });
      const info=this.closest('.product__info');
      this.variantListeners=[];
      info?.querySelectorAll('form[action*="/cart/add"]').forEach(form=>{
        if(form===this.form)return;
        const handler=event=>{
          if(this.busy)return;
          const id=event.detail?.variant?.id,select=this.querySelector('[data-main-product] [data-fv-pair-variant]');
          if(!id||!select)return;
          const valid=select.tagName==='SELECT'?[...select.options].some(option=>option.value===String(id)):select.value===String(id);
          this.mainVariantUnavailable=!valid;
          if(valid)select.value=String(id);
          this.update();
        };
        form.addEventListener('variant:change',handler);this.variantListeners.push([form,handler]);
      });
      this.update();
      this.dataset.fvBundleInitialization='bound';
    }
    disconnectedCallback(){this.variantListeners?.forEach(([form,handler])=>form.removeEventListener('variant:change',handler));}
  }

  if(!customElements.get('foviel-pairing'))customElements.define('foviel-pairing',FovielPairing);
  class FovielSpotlight extends HTMLElement{
    connectedCallback(){
      if(this.bound)return;this.bound=true;this.cards=[...this.querySelectorAll('[data-fv-spotlight-card]')];this.index=0;
      const key='foviel-style-dismissed-until';
      const dismissed=()=>{try{return Number(sessionStorage.getItem(key)||0)>Date.now();}catch{return false;}};
      const hide=()=>this.cards.forEach(card=>card.hidden=true);
      this.show=()=>{
        hide();
        if(!this.isConnected||!this.cards.length||dismissed())return;
        const blocked=document.hidden||document.querySelector('dialog[open],.drawer[open],cart-drawer[open]');
        if(blocked){this.timer=setTimeout(this.show,10000);return;}
        this.cards[this.index++%this.cards.length].hidden=false;
        this.timer=setTimeout(()=>{hide();this.timer=setTimeout(this.show,45000);},8500);
      };
      this.addEventListener('click',event=>{if(event.target.closest('.fc-popular-close')){clearTimeout(this.timer);hide();try{sessionStorage.setItem(key,String(Date.now()+30*60*1000));}catch{}}});
      this.onVisibility=()=>{clearTimeout(this.timer);hide();if(!document.hidden&&!dismissed())this.timer=setTimeout(this.show,12000);};
      document.addEventListener('visibilitychange',this.onVisibility);
      if(!dismissed())this.timer=setTimeout(this.show,12000);
    }
    disconnectedCallback(){clearTimeout(this.timer);document.removeEventListener('visibilitychange',this.onVisibility);}
  }
  if(!customElements.get('foviel-style-spotlight'))customElements.define('foviel-style-spotlight',FovielSpotlight);
  class FovielProductCopy extends HTMLElement{
    connectedCallback(){
      if(this.bound)return;this.bound=true;
      for(const link of this.querySelectorAll('a[href]')){
        const href=link.getAttribute('href');
        if(href.startsWith('#'))continue;
        // Keep genuine same-store product, collection and help navigation.
        try{
          const destination=new URL(href,window.location.href);
          if(destination.origin===window.location.origin&&/^\/(?:collections|products|pages|blogs)\//.test(destination.pathname))continue;
        }catch{}
        const text=document.createElement('span');
        text.append(...link.childNodes);
        link.replaceWith(text);
      }
    }
  }
  if(!customElements.get('foviel-product-copy'))customElements.define('foviel-product-copy',FovielProductCopy);
  const bindProductLayout=()=>{
    document.querySelectorAll('[data-fv-product-page]').forEach(page=>{
      if(page.dataset.fvLayoutBound)return;page.dataset.fvLayoutBound='true';
      const gallery=page.querySelector('.product__gallery-container');
      if(!gallery)return;
      const update=()=>{
        const header=document.querySelector('.header-section');
        const offset=(header?.getBoundingClientRect().height||0)+16;
        page.style.setProperty('--fv-gallery-offset',offset+'px');
        page.classList.toggle('fv-gallery-fits',wide.matches&&gallery.getBoundingClientRect().height<=innerHeight-offset-16);
      };
      update();
      const observer=new ResizeObserver(update);
      observer.observe(gallery);
      const header=document.querySelector('.header-section');
      if(header)observer.observe(header);
      window.addEventListener('resize',update);
      const unload=event=>{
        if(!event.target.contains(page))return;
        observer.disconnect();window.removeEventListener('resize',update);
        document.removeEventListener('shopify:section:unload',unload);
      };
      document.addEventListener('shopify:section:unload',unload);
    });
  };
  const stableHeader=()=>{const h=document.querySelector('.header-section');if(h){h.classList.remove('header-hidden','header-nav-scrolled');}document.body.classList.remove('unloading');};
  const init=()=>{bindMenus();bindFooter();stableHeader();bindProductLayout();};
  window.addEventListener('pageshow',stableHeader);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();

// Keep floating entry points clear of the three isolated mobile option pickers.
(()=>{
  const info=document.querySelector('.product__info');
  if(!info||!info.querySelector('variant-picker[data-fv-apparel-pilot]'))return;
  const mobile=matchMedia('(max-width:767px)');
  let picker,visible=false;
  const update=()=>document.body.classList.toggle('fv-apparel-options-visible',mobile.matches&&visible);
  const observer=new IntersectionObserver(entries=>{
    for(const entry of entries)if(entry.target===picker)visible=entry.isIntersecting;
    update();
  });
  const bind=()=>{
    const next=info.querySelector('variant-picker[data-fv-apparel-pilot]');
    if(next===picker)return;
    if(picker)observer.unobserve(picker);
    picker=next;
    visible=false;
    if(picker)observer.observe(picker);
    update();
  };
  bind();
  new MutationObserver(bind).observe(info,{childList:true,subtree:true});
  mobile.addEventListener('change',update);
})();
